import { com } from '@eidu/form'

import Field = com.eidu.sharedlib.entity.field.Field
import FieldType = com.eidu.sharedlib.entity.field.FieldType

export const ORDER_FIELD_NAME = '-- Order'
export const ORDER_FIELD_SUFFIX = ' -- Order'

export const isOrderField = (field: Field): boolean =>
  field.name.trim() === ORDER_FIELD_NAME && field.type === FieldType.Number

export const isManualOrderField = (field: Field): boolean => {
  if (field.type !== FieldType.Number) return false
  const trimmed = field.name.trim()
  return trimmed === ORDER_FIELD_NAME || trimmed.endsWith(ORDER_FIELD_SUFFIX)
}
